import { Component, ViewChild } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { FitnessPlanService } from './fitness-plan.service';
import { BasicInfoComponent } from './basic-info/basic-info.component';
import { NgForOf } from '@angular/common';
import { CommonModule, formatDate } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fitness-plan',
  standalone: true,
  imports: [
    MatListModule,
    NgForOf,
    CommonModule,
    FormsModule,
    MatPaginator,
    MatPaginatorModule,
    BasicInfoComponent,
  ],
  templateUrl: './fitness-plan.component.html',
  styleUrl: './fitness-plan.component.css',
})
export class FitnessPlanComponent {
  constructor(private service: FitnessPlanService, private router: Router) {}
  @ViewChild('paginator') paginator: MatPaginator;
  memberList: any = [];
  countRes: any = [];
  filter: any = 'all';
  timeout: any = null;
  name: any = '';
  resp: any = [];
  previousPageSize: any = 10;
  pageIndex: any = 1;
  activeTab: string = 'all';

  ngOnInit(): void {
    this.getFitnessPlans(this.pageIndex, 10, this.name);
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.filter = tab;
    this.paginator.pageIndex = 0;
    this.pageIndex = 1;
    this.memberList = [];
    this.getFitnessPlans(this.pageIndex, 10, this.name);
  }
  searchByMember(event: any) {
    this.paginator.pageIndex = 0;
    this.pageIndex = 1;
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.executeListing(event.target.value);
      }
    }, 500);
  }
  executeListing(searchValue: any) {
    this.name = searchValue;
    this.memberList = [];
    this.getFitnessPlans(this.pageIndex, this.paginator.pageSize, this.name);
  }

  pageChangeEvent(page: any) {
    if (page.pageSize != this.previousPageSize) {
      this.paginator.pageIndex = 0;
    }
    this.previousPageSize = page.pageSize;
    this.pageIndex = this.paginator.pageIndex + 1;
    this.getFitnessPlans(this.pageIndex, this.paginator.pageSize, this.name);
  }

  getFitnessPlans(pageNo: number, pageSize: number, name: any) {
    this.memberList = [];
    if (name == '') {
      if (this.activeTab === 'unassigned') {
        this.service
          .searchFPPerMember(pageNo, pageSize, '')
          .subscribe((response) => {
            this.resp = response;
            this.populateList();
          });
      } else {
        this.service.getFPAllMembers(pageNo, pageSize).subscribe((response) => {
          this.resp = response;
          this.populateList();
        });
      }
    } else {
      this.service
        .searchFPPerMember(pageNo, pageSize, name)
        .subscribe((response) => {
          this.resp = response;
          this.populateList();
        });
    }
  }

  populateList() {
    let list = this.resp.members.data;

    // Apply client-side filtering based on the active tab
    if (this.activeTab === 'all') {
      // Show all members
      this.createMemberGrid(list);
    } else if (this.activeTab === 'unassigned') {
      // Show only unassigned members (those who don't have an active plan covering current + next 2 days)
      const filteredList = list.filter(
        (member: any) => !this.isMemberAssigned(member)
      );
      this.createMemberGrid(filteredList);
    }
  }

  private createMemberGrid(list: any[]) {
    for (let i = 0; i < list.length; i += 3) {
      this.memberList.push(list.slice(i, i + 3));
    }
  }

  private isMemberAssigned(member: any): boolean {
    // Check if member has startTime and endTime
    if (!member.startTime || !member.endTime) {
      return false;
    }

    try {
      // Parse dates ignoring timezone
      const startDate = this.parseISODateIgnoreTimezone(member.startTime);
      const endDate = this.parseISODateIgnoreTimezone(member.endTime);

      // Get current date and next two days
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day

      const dayAfterTomorrow = new Date(today);
      dayAfterTomorrow.setDate(today.getDate() + 2); // Current day + next 2 days

      // Check if the plan covers the current day and next two days
      // Plan is considered active if it starts on or before day after tomorrow
      // and ends on or after today
      return startDate <= dayAfterTomorrow && endDate >= today;
    } catch (error) {
      console.error('Error checking member assignment status:', error);
      return false;
    }
  }

  private parseISODateIgnoreTimezone(isoDateString: string): Date {
    // Extract just the date part and create a local date without timezone conversion
    // Input format: "2025-06-10T00:00:00Z"
    // Extract: "2025-06-10"
    const datePart = isoDateString.split('T')[0];
    const [year, month, day] = datePart
      .split('-')
      .map((num) => parseInt(num, 10));
    // Create date in local timezone (month is 0-indexed in JavaScript Date constructor)
    return new Date(year, month - 1, day);
  }

  navigateToTemplates() {
    // Navigate to fitness plan templates management page
    // You can customize this route based on your application's routing structure
    this.router.navigate(['/fitness-plan/templates']);
  }
}
